import React from 'react';
import {Box, Card, CardContent, Stack, Typography, Container, useMediaQuery} from '@mui/material';
import QueueScheduleCard from "./QueueScheduleCard";

function Homepage({queue, groupId}) {

    return (
        <Container maxWidth='md'>
            <Box>
                <Typography align="center" sx={{fontSize: '1.3rem', fontWeight: 600, padding: '10px 5px'}}>
                    Welcome to SFU Starry Nights
                </Typography>
            </Box>
            <Box>
                {queue &&
                    <Card
                        elevation={1}
                        rounded="true"
                        sx={{
                            maxWidth: 800,
                            margin: 'auto'
                        }}>
                        <CardContent>
                            <Stack spacing={2}>
                                <QueueScheduleCard queue={queue} groupId={groupId}/>
                            </Stack>
                        </CardContent>
                    </Card>
                }
            </Box>

        </Container>

    );
}

export default Homepage;